<template>
  <div>
    <div class="account-wrap">
      <h2 class="account-title">订单账单信息</h2>
      <cell-box :column="1" class="account-info">
        <cell-item label="订单号：" :value="info.OrderNo" />
        <cell-item label="联系人：" :value="info.Contact" />
        <cell-item label="联系电话：" :value="info.Phone" />
        <cell-item label="房号：" :value="info.RoomNos" />
        <cell-item label="入住日期：" :value="info.CheckInDate" />
        <cell-item label="离店日期：" :value="info.CheckOutDate" />

        <cell-item label="渠道：" :value="info.ChannelName" />
        <cell-item label="协议客户：" :value="info.CustomerName" />
        <cell-item label="会员卡号：" :value="info.MemberCardNo" />
        <cell-item label="备注：" :value="info.Remark" />
      </cell-box>
      <table class="account-table">
        <tr>
          <th>日期</th>
          <th>项目</th>
          <th>数量</th>
          <th>金额</th>
        </tr>
        <tr v-for="(item, index) in info.GuestAccounts" :key="index">
          <td>{{ item.AccountDate }}</td>
          <td>{{ item.AccountItemName }}</td>
          <td>{{ item.Quatity }}</td>
          <td>{{ item.Amount }}</td>
        </tr>
      </table>

      <div class="sum-box">
        <div class="sum-item">
          <strong>消费合计：</strong>
          <span style="color:#f00"> &yen;{{ info.ConsumeSum }} </span>
        </div>
        <div class="sum-item">
          <strong>收款合计：</strong>
          <span style="color:#f00"> &yen;{{ info.PaymentSum }} </span>
        </div>
        <div class="sum-item">
          <strong>余&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;额：</strong>
          <span style="color:#f00"> &yen;{{ info.Balance }} </span>
        </div>
      </div>
      <div class="sign-name">
        <img :src="'data:image/jpeg;base64,' + info.Base64Image" alt="" />
      </div>
    </div>
    <van-goods-action>
      <van-button type="info" block @click="toSign">
        {{ info.Base64Image ? "重新签名" : "签名" }}
      </van-button>
    </van-goods-action>
  </div>
</template>

<script>
import "./sign.less";
import { getBillInfo } from "@/api/sign.js";
import { CellBox, CellItem } from "@/components/cell";
import { Button, Panel, GoodsAction, Row, Col } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Panel.name]: Panel,
    [Row.name]: Row,
    [Col.name]: Col,
    [GoodsAction.name]: GoodsAction,
    CellBox,
    CellItem,
  },
  data() {
    return {
      id: "",
      info: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    getInfo() {
      getBillInfo({ Id: this.id }).then(res => {
        this.info = res.Data;
      });
    },
    toSign() {
      this.$router.push({
        name: "signPanel",
        query: {
          orderId: this.id,
          type: 1,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
